// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed here.

(function($) {
    $(document).ready(function() {

      // всплывашки с формами
      $('.fancy-form').fancybox({
        touch: false,
        modal: false
      });
      $('[data-fancybox]').fancybox({
        touch: false,
        modal: false
      });

      $(document).keyup(function(e) {
        if (e.keyCode == 27) {
          $('.fancybox-close-small').click();
        }
      });

      $('.block__content .item_img').photobox('a',{ time:0 }); // сертификат в блоке


      // поиск по клику
      $('#search_link').click(function() {
        $('.block--search-box').toggleClass('search_active');
        ym(102417570,"reachGoal","webit_search_click"); return true;
      });

      // менюшка на мобильном
      $('.menu_acc').click(function() {
        $(this).toggleClass('active');
      });

      // кастомные настройки для страничек
      if (window.location.href.includes("/complete")){
        document.getElementsByTagName("h1")[0].innerHTML="Заказ оформлен";
        document.getElementsByClassName("breadcrumb-item")[3].innerHTML="Заказ оформлен";
      }
      if (window.location.href.includes("/uslugi-1s/ustanovka-i-nastroyka")){
        document.querySelector('.field--name-field-services-paragraph-top').insertAdjacentHTML("beforebegin", '<div class=\"container\"><div class=\"row\"><h2>Что дает предприятию внедрение 1С?</h2></div></div>');
      }
      if (window.location.href.includes("/uslugi-1s/integraciya-1s")){
        document.querySelector('.field--name-field-services-paragraph-top').insertAdjacentHTML("beforebegin", '<div class=\"container\"><div class=\"row\"><h2>Популярные варианты интеграции</h2></div></div>');
      }

      // add onclick attr yandex goals
      // multiple - webit_requestConsult_click
      $('.node-type--multipage .view-bgheaders .bg_text a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_requestConsult_click\');');
      // services - webit_requestConsult_click
      $('.node-type--services .view-bgheaders .bg_text a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_requestConsult_click\');');
      // products - webit_buy_click
      $('.node-type--products .view-bgheaders .bg_text a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_buy_click\');');
      $('.node-type--products .paragraph--type--tariff .field--name-field-tariff-custom-link a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_buy_click\');');
      // products - calc form - webit_orderCalc_click
      $('.node-37 .calc_block .order-button').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_orderCalc_click\');');
      // service - form - webit_orderService_click
      $('.node-2 #paragraph-id--152 .field--name-field-paragraph-content-body a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_orderService_click\');');
      $('.node-19 .view-services-tariff .field--name-field-tariff-custom-link a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_orderService_click\');');
      // cart link - webit_click_cart
      $('.view-equipment-products .views-row .cart-link a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_click_cart\');');
      // cart form checkout - webit_completeOrder_click
      $('.cart-form-page #edit-checkout').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_completeOrder_click\');');
      // blog link
      $('.block--articles-block-front .view-header a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_click_blog\');');
      $('.block--footer-about .nav li:nth-child(1) a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_click_blog\');');
      $('.block--mainmenu-box .nav li:nth-child(3) a').attr('onClick', 'yaCounter102417570.reachGoal(\'webit_click_blog\');');

      // utm
      function getUrlParameterByName(name) {
        var name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
        var regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
        var results = regex.exec(location.search);
        return results === null
          ? ""
          : decodeURIComponent(encodeURIComponent(results[1].replace(/\+/g, " ")));
      }
      function getUtmPoint(name) {
        var points = localStorage.getItem("utm_points");

        if (points) {
          return JSON.parse(points)[name];
        }
      }
      function getCookie(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(encodeURIComponent(document.cookie));
        var ca = decodedCookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
      function saveUtmPoint() {
        if (!getUtmPoint("utm_source")) {
          var referer_domain = document.referrer
            ? new URL(document.referrer).hostname
            : "";
          var points = {
            utm_source: getUrlParameterByName("utm_source"),
            utm_campaign: getUrlParameterByName("utm_campaign"),
            utm_medium: getUrlParameterByName("utm_medium"),
            utm_content: getUrlParameterByName("utm_content"),
            url: location.href,
            referer: document.referrer,
            referer_domain: referer_domain
          };

          // if (utm_source) {
          localStorage.setItem("utm_points", JSON.stringify(points));
          // }
        }
      }
      function setCookie(cname,cvalue,exhours) {
        var d = new Date();
        d.setTime(d.getTime() + (exhours*60*60*1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
      }
      function saveUtmCookies () {
        if (!getCookie("utm_source")) { /* Если кукис нет, записываем новые */
          var referer_domain = document.referrer
            ? new URL(document.referrer).hostname
            : "";
          if (window.location.href.includes("?") && window.location.href.includes("utm")) {
            var transferredParams = window.location.href.split("?").pop();
          }
          var points = {
            utm_source: getUrlParameterByName("utm_source"),
            utm_campaign: getUrlParameterByName("utm_campaign"),
            utm_medium: getUrlParameterByName("utm_medium"),
            utm_content: getUrlParameterByName("utm_content"),
            url: window.location.href,
            transferredParams: transferredParams,
            referer: document.referrer,
            referer_domain: referer_domain
          };
          for (var [key, value] of Object.entries(points)) {
            if (value) {
              setCookie(key, value, 6);
            }
          }
        }
      }
      saveUtmPoint();
      saveUtmCookies();
      if (getCookie("transferredParams")) {
        window.history.pushState( {} , '', '?' + getCookie("transferredParams") );
      }
      setCookie('url', window.location.href, 6);
      setCookie('referer', document.referrer, 6);

      // popup forms
      var popupTimeout = setTimeout(() => {
        if ($(".fancybox-overlay").length) {
          clearTimeout(popupTimeout);
        } else {
          $.fancybox.open($("#popup_order"), {padding: 0});
        }
      }, 30000);

      // cookie msg
/*      const container_cookie = document.querySelector(".warning");
      if (document.cookie.indexOf("warning") != -1) {
        container_cookie.classList.remove("warning--active");
      }

      if (document.querySelector(".warning")) {
        const apply = container_cookie.querySelector(".warning__apply");
        apply.addEventListener("click", () => {
          container_cookie.classList.remove("warning--active");
          document.cookie = "warning=true; max-age=2592000; path=/";
        });
      };*/

      // куки
      function checkCookies(){
        let cookieDate = localStorage.getItem('cookieDate');
        let cookieNotification = document.getElementById('notes_cookie');
        let cookieBtn = cookieNotification.querySelector('.warning__apply');
        // Если записи про кукисы нет или она просрочена на 1 год, то показываем информацию про кукисы
        if( !cookieDate || (+cookieDate + 31536000000) < Date.now() ){
          cookieNotification.classList.add('warning--active');
        }
        // При клике на кнопку, в локальное хранилище записывается текущая дата в системе UNIX
        cookieBtn.addEventListener('click', function(){
          localStorage.setItem( 'cookieDate', Date.now() );
          cookieNotification.classList.remove('warning--active');
        })
      }
      checkCookies();

    });
})(jQuery);

